import { IMDSPopoverProps } from "./popover.types";
import { StyledPopover } from "./popover.style";

/**
 * Note:
 * - For popovers toggleable only when the control button is clicked, use the `isNonModal` prop.
 * - We use `style` for z-index just due to the way react-aria handles style merging.
 */
export const MDSPopover = ({ styling = true, zIndex, ...props }: IMDSPopoverProps) => {
  return <StyledPopover $styling={styling} style={{ zIndex: zIndex }} {...props} />;
};
